import { useMutation } from '@tanstack/react-query';
import { ApiError } from '@src/services/api';
import { ApiTypes } from 'common';
import { queryClient, QUERY_KEYS, QUERY_PREFIX } from '@src/query';
import { updateMediaFindData } from './useQueryMediaFind';
import { deleteRightsRequest } from './api';

export const useMutationRightsRequestDelete = () => useMutation<ApiTypes.ResDeleteRightsRequest, ApiError, {
  mediaId: string
}>({
  mutationFn: ({ mediaId }) => deleteRightsRequest(mediaId),
  onSuccess: async (res, { mediaId }) => {
    // update optimistically for user satisfaction
    // and then refresh media to have perfectly updated results
    res.forEach((id) => {
      updateMediaFindData(id, { rightsRequestStatus: undefined });
      // refetch media for detailed view
      queryClient.refetchQueries({ queryKey: QUERY_KEYS.media(id) });
    });
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.mediaFind() });
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.collectionsMedia() });
    queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX.MEDIA_SIMILAR] });
    queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX.MEDIA_CAROUSEL] });
  },
});
